export default "__VITE_ASSET__233e5ff1__"